import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";
import { Link } from "react-router-dom";

import withAjaxStatus from "../../../support/hoc/withAjaxStatus";

import "../schools/List.css";

class List extends Component {
    static permission = "Admin.SpecialGroups";

    componentDidMount() {
        if (this.props.onLoad) {
            this.props.onLoad();
        }
    }

    render() {
        return (
            <div className="admin-institution-list">
                <ReactTable
                    data={this.props.specialGroups}
                    minRows={0}
                    columns={[
                        {
                            Header: "Name",
                            accessor: "name",
                            minWidth: 150,
                        },
                        {
                            Header: "Description",
                            accessor: "description",
                            minWidth: 200,
                        },
                        {
                            Header: "Status",
                            accessor: "isActive",
                            Cell: (data) => <span>{data.original.isActive ? "Active" : "Inactive"}</span>,
                            maxWidth: 120,
                        },
                        {
                            Header: "",
                            accessor: "id",
                            minWidth: 60,
                            Cell: (row) => {
                                const url = `/admin/specialgroups/${row.value}`;
                                return <Link to={url}>Edit</Link>;
                            },
                        },
                        {
                            Header: "",
                            accessor: "id",
                            id: "toggleActive",
                            minWidth: 90,
                            Cell: (row) => {
                                const group = row.original;
                                const label = group.isActive ? "Deactivate" : "Reactivate";
                                return (
                                    <a
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            this.props.onToggleActive(group);
                                        }}
                                    >
                                        {label}
                                    </a>
                                );
                            },
                        },
                    ]}
                    defaultPageSize={50}
                    className="-striped -highlight"
                />
            </div>
        );
    }
}

List.propTypes = {
    specialGroups: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
            description: PropTypes.string,
            isActive: PropTypes.bool,
        })
    ),
    onToggleActive: PropTypes.func.isRequired,
    onLoad: PropTypes.func,
};

List = withAjaxStatus(List);
export default List;
